export default __webpack_public_path__ + "static/media/industry-mix-2.f71304f4.jpg";